const submitFormCases = {
  submitFormV2: 'submitFormV2',
};

export { submitFormCases };
